<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Canteen Daily Meal Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col sm="4" md="3" cols="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="current_academic_year"
            :items="academic_year_list"
            item-text="ay"
            return-object
            label="Academic Year"
            outlined
            persistent-hint
            hint="Please Select Academic Year"
            @change="getInstallmentData()"
          ></v-autocomplete>
        </v-col>
        <v-col sm="4" md="3" cols="12" v-if="canteen_installment_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="installment"
            multiple
            :items="canteen_installment_list"
            item-text="name"
            item-value="id"
            label="Canteen Installment"
            outlined
            persistent-hint
            hint="Please Select Installment"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row justify="center" dense v-if="canteen_installment_list != ''">
        <v-col sm="6" md="4" cols="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            v-model="stream"
            :items="stream_list"
            item-text="stream"
            item-value="id"
            label="Stream"
            outlined
            @change="
              getStreamData();
              stud = null;
            "
            persistent-hint
            hint="Please Select Stream"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col sm="6" md="4" cols="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="std"
            multiple
            :items="standard_list"
            item-text="standard"
            item-value="id"
            label="Standard"
            outlined
            persistent-hint
            hint="Please Select Standard"
            @change="stud = null"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <!-- <v-row dense justify="center" v-if="stud_list != ''">
        <v-col sm="6" md="4" cols="12">
          <center>
            <span class="mt-5 pt-5"><strong>OR</strong></span>
          </center>
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="stud"
            multiple
            :items="stud_list"
            item-text="registration_number"
            item-value="lid"
            label="Student"
            outlined
            persistent-hint
            hint="Please Select Student"
            @change="
              stream = '';
              std = '';
            "
          ></v-autocomplete>
        </v-col>
      </v-row> -->
      <v-row dense justify="center">
        <v-col sm="3" cols="12" md="2">
          <v-btn
            rounded
            class="button mt-6"
            :loading="loader"
            @click="getReport()"
            >Get Report</v-btn
          >
        </v-col>
      </v-row>
      <v-card class="box" v-if="data_list != ''">
        <!-- export btn  code -->
        <!-- <download-excel
          class="mr-2 pb-3 pt-2"
          :data="bookList1"
          :fields="table_fields"
          worksheet="Canteen_Daily_Meal_Report"
          name="Canteen_Daily_Meal_Report.xls"
        >
          <v-btn color="success" outlined rounded>
            <v-icon dark>mdi-file-excel</v-icon> Export
          </v-btn>
        </download-excel> -->
        <v-btn
            rounded
            class="mr-2 pb-3 pt-2"
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'CanteenDailyMealReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
          <div id="my-table-id">
        <v-data-table
          :headers="headers"
          :items="bookList1"
          :search="search"
          class="elevation-1 mytable"
          dense
          v-if="data_list != ''"
          @current-items="getFiltered"
        >
          <template v-slot:top class="pb-5">
            <v-row dense justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row dense>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete
                            class="mr-2 pb-5 pt-2"
                            flat
                            hide-details
                            small
                            rounded
                            dense
                            outlined
                            color="#0F2027"
                            :label="header.text"
                            multiple
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                          ></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
        </v-data-table>
          </div>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      loader: false,
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      current_academic_year: null,
      stream: "",
      std: [],
      academic_year_list: null,
      standard_list: null,
      dision_list: [],
      stream_list: null,
      canteen_installment_list: [],
      installment: [],
      data_list: [],
      filterArr: [],
      filters: {
        installment: [],
        reg_no: [],
        standard: [],
        div: [],
      },
      stud_list: [],
      stud: null,
      show_stud_list: true,
      table_fields: {
        "Sr. No": "sr_no",
        "Academic Year": "academicyear",
        "Registration No.": "reg_no",
        Name: "name",
        Standard: "standard",
        Division: "division",
        Installment: "installment",
        "From Date": "installment_start_date",
        "To Date": "installment_end_date",
      },
      headers: [
        {
          text: "Sr.No.",
          align: "left",
          sortable: false,
          value: "sr_no",
        },
        {
          text: "Academic Year",
          align: "left",
          sortable: false,
          value: "academicyear",
        },
        {
          text: "Registration No.",
          align: "left",
          sortable: false,
          value: "reg_no",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Standard",
          align: "left",
          sortable: false,
          value: "standard",
        },
        {
          text: "Division",
          align: "left",
          sortable: false,
          value: "div",
        },
        {
          text: "Installment",
          align: "left",
          sortable: false,
          value: "installment",
        },
        {
          text: "From Date",
          align: "left",
          sortable: false,
          value: "installment_start_date",
        },
        {
          text: "To Date",
          align: "left",
          sortable: false,
          value: "installment_end_date",
        },
      ],
    };
  },
  computed: {
    bookList1() {
      return this.data_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No</th>
      <th>Academic Year</th>
      <th>Registration No.</th>
      <th>Name</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Installment</th>
      <th>From Date</th>
      <th>To Date</th>
      
    </tr>`;

  this.data_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td> 
        <td>${item.academicyear}</td>
        <td>${item.reg_no}</td>
        <td>${item.name}</td>
        <td>${item.standard}</td>
        <td>${item.div}</td>
        <td>${item.installment}</td>
        <td>${item.installment_start_date}</td>
        <td>${item.installment_end_date}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.data_list.map((d) => d[val]);
    },
   
    ExportToExcel() {
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    },
    getReport() {
      const data = {
        ay: this.current_academic_year.id,
        std: this.std,
        stream: this.stream,
        installment: this.installment,
        stud_list: this.stud,
      };
      this.loader = true;
      axios
        .post("/Canteen/getCanteenMealReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.loader = false;
            this.data_list = res.data.data_list;
            if(this.data_list==''){
               this.showSnackbar("#b71c1c", "No Records Found..!!!");
               return
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getInstallmentData() {
      this.overlay = true;
       this.canteen_installment_list=[]
       const data = {
        academicYear: this.current_academic_year.id,
      };
      axios
        .post("/Canteen/getInstallmentDataByAy",data)
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.canteen_installment_list = res.data.canteen_installment_list;
           // this.stud_list = res.data.stud_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getStreamData() {
      // if (this.show_stud_list) {
      //   this.show_stud_list = false;
      // }
      // if ((this.show_stud_list = false)) {
      //   this.show_stud_list = true;
      // }
      const data = {
        ay: this.current_academic_year.id,
        stream: this.stream,
      };
      axios
        .post("/InstallmentStructureDetails/getStreamData", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "No division for this stream / Stream mapping not done for selected stream!!!"
            ); // show snackbar on error
            return;
          }
          if (res.data.flag == "YES") {
            this.standard_list = res.data.standard_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    onload() {
      axios
        .post("/InstallmentStructureDetails/getAllData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.ay_data;
            // this.current_academic_year = res.data.cay;
            this.stream_list = res.data.stream_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.get_ay_std_ft_loader = false;
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
